/**
 * Builds a Standard deck from the player's owned collection.
 * Targets the same 40-card mix as `STANDARD_DECK` (20 monsters + 20 S/T).
 * Copy counts stay inside the house banlist. Within each bucket the cards
 * with a recorded win rate this season go in first; the rest fill at random.
 */

import {
  buildStandardDeck,
  houseLimits,
  ownedMainCopyCount as countOwnedMain,
  type CardWinSample,
  type StandardDeckCard,
} from '@shared/index'

export type AutoDeckCard = StandardDeckCard & { [key: string]: unknown }

export type { CardWinSample }

export function ownedMainCopyCount(
  catalog: AutoDeckCard[],
  owned: Record<string, number>,
): number {
  return countOwnedMain(catalog, owned, houseLimits())
}

export function buildOwnedStandardDeck(
  catalog: AutoDeckCard[],
  owned: Record<string, number>,
  rates: Readonly<Record<string, CardWinSample>> = {},
): { main: AutoDeckCard[]; extra: AutoDeckCard[] } {
  return buildStandardDeck(catalog, owned, {
    rates,
    copyLimits: houseLimits(),
  })
}
